import React, { ReactElement, useState } from 'react';
import { PrimaryButton } from '@acko-tech/building-blocks.ui.button';
import * as Styles from './styles';
import {
    TAP_BTN_ADSC_CALL_NOW,
    TAP_BTN_SCHEDULE_CALLBACK,
} from '@/analytics/events';
import { trackEventAPI } from '@/analytics/middleware';

const isWithinWorkingHours = function () {
    const now = new Date();
    const currentHours = now.getHours();
    const currentMinutes = now.getMinutes();
    const startHour = 9; // 9 AM
    const endHour = 19; // 7 PM
    const currentTimeInMinutes = currentHours * 60 + currentMinutes;
    const startTimeInMinutes = startHour * 60;
    const endTimeInMinutes = endHour * 60;
    return (
        startTimeInMinutes <= currentTimeInMinutes &&
        currentTimeInMinutes < endTimeInMinutes
    );
};

const textMapping: { [key: string]: ReactElement } = {
    textWorkingHours: (
        <>
            {/* Schedule a callback, and we will contact you in{' '}
            <span>5 minutes</span> */}
        </>
    ),
    textOutsideWorkingHours: (
        <>
            Schedule a callback and we’ll contact you tomorrow between{' '}
            <span>09:00 AM and 07:00 PM</span>
        </>
    ),

    textOnClick: (
        <>
            We will contact you in <span>5 minutes</span>
        </>
    ),
    textOutsideWorkingOnClick: (
        <>
            We will contact you tomorrow between{' '}
            <span>09:00 AM and 07:00 PM</span>
        </>
    ),
};
export default function CallBackCard() {
    const [isButtonClicked, setIsButtonClicked] = useState(false);
    const isWorkingHour = isWithinWorkingHours();

    const handleButtonClick = () => {
        trackEventAPI({
            event_name: isWorkingHour
                ? TAP_BTN_ADSC_CALL_NOW
                : TAP_BTN_SCHEDULE_CALLBACK,
            customAttributes: {
                adsc_price_seen:
                    localStorage.getItem('price-seen') === 'true'
                        ? true
                        : false,
            },
            isFakeDoor: true,
        });

        if (isWorkingHour) {
            //Todo:-this  number needs to be dynamic
            window.open('tel:18002669293', '_self');
        } else {
            setIsButtonClicked(true);
        }
    };

    return (
        <Styles.Container>
            <Styles.Upper>
                <Styles.CallHelpDesk />
                <Styles.TextContent>
                    <Styles.Heading>
                        Want to talk to our car expert?
                    </Styles.Heading>
                    <Styles.SubHeading>
                        {!isButtonClicked
                            ? isWorkingHour
                                ? textMapping['textWorkingHours']
                                : textMapping['textOutsideWorkingHours']
                            : isWorkingHour
                              ? textMapping['textOnClick']
                              : textMapping['textOutsideWorkingOnClick']}
                    </Styles.SubHeading>
                </Styles.TextContent>
            </Styles.Upper>
            {!isButtonClicked && (
                <Styles.ButtonWrapper>
                    <PrimaryButton onClick={handleButtonClick}>
                        <Styles.ButtonContent>
                            <Styles.Call />
                            {isWorkingHour ? 'Call Now' : 'Schedule callback'}
                        </Styles.ButtonContent>
                    </PrimaryButton>
                </Styles.ButtonWrapper>
            )}
        </Styles.Container>
    );
}
